import { Paper } from "@mui/material";
import React, { Component } from 'react';
import FollowUpRutin from "./FollowUpRutin";

class FollowupRutinWrapper extends Component {
    state = {  } 
    render() { 
        return (
            <>
                <FollowUpRutin {...this.props} showBackButton={true} fuType={2} title={"Follow Up Rutin 2"} />
                <br />
                <FollowUpRutin {...this.props} showBackButton={false} fuType={3} title={"Follow Up Rutin 3"} />
                <br />
                <FollowUpRutin {...this.props} showBackButton={false} fuType={4} title={"Follow Up Rutin 4"} />
            </>        
        );
    }
}
 
export default FollowupRutinWrapper;